export const electronicSignatureSettingsDefaultValue = [
  {
    id: 1,
    type: 'sat',
    isEnabled: true,
    displayName: 'SAT',
    default: true,
    isMultiSign: false,
  },
  {
    id: 2,
    type: 'firel',
    isEnabled: true,
    displayName: 'Firel',
    isMultiSign: true,
    isMultiSignDisplayName: true,
    multiSignDisplayName: 'PFX',
  },
];
